module.exports = __webpack_public_path__ + "img/gift.4b28d027.png";